class Point {
    constructor(x = 0, y = 0) {
        this.x = x
        this.y = y
    }
}
export default Point